module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("A voice mail, text message, and two missed calls told Evan that Andrew Leary was anxious for an update, but he would have to wait. The call of the Ritual could not be ignored.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In the taxi crossing the Triborough Bridge, as he passed the ominously majestic nuthouse, Evan thought about the monthly Ridgewood Academy Alumni newsletter, which, he believed, should be delivered to "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("his")]), _vm._v(" door with a barf bag. Reading the alumni update, seeing the rich a-holes get married, spawn little rich a-holes and, then, worst of all, get "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("richer")]), _vm._v(", left him envious, delirious, and nauseated. Usually the very thought of it had this effect, but not today. No. Today he recalled Gore Vidal’s famous aphorism: “Whenever a friend succeeds, a little something in me dies.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Nothing could be more true")]), _vm._v(", Evan admitted. He knew a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("big")]), _vm._v(" something would die in the Ridgewood assholes when they learned of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("his")]), _vm._v(" success. He would report his Wall Street promotion and the deals he was closing. His “children” wore green and earned interest, and his tormenters would be shocked. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Good. Fuck them")]), _vm._v(". His taxi banked left onto the Drive, and Evan snapped back to reality. The alumni update could wait. The Ritual called.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB1"
  }, [_vm._v("Evan jumped out of the cab a couple of blocks north of his destination and walked to the shadow of his Dutch elm tree.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Worried that he was too late and had missed the show, he stood there with his Canal Street “Executive Roller Bag” leaning against the trunk. Its presence annoyed him. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Pathetic piece of shit")]), _vm._v(". Evan hated cheap luggage.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His ECM-issued BlackBerry vibrated.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Andrew. Hey. Yeah, I’m just leaving Louisville. Major delay here. Very positive meeting. Serious banking possibilities. We’ll talk in the morning, okay? Great.” Click.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("If Evan was the boss, he’d certainly know his minion’s flight number so he could punch it up on the Web and catch the idiot in a lie, but Andrew trusted people. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Sucker.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("At six thirty, without much deliberation for a change, he decided he’d missed them; he should have known. The weather was perfect and Geoffrey had decided to beat the traffic. On most Fridays, as punishment, he would have sentenced himself to a lap around the reservoir. Sometimes, after a particularly memorable sighting, the same lap was a much-deserved reward. He couldn’t explain this phenomenon, only that the park was his sanctuary where he could perform complicated mental machinations. The cinder track around the reservoir evoked thoughts and emotions bigger and better than Evan thought himself capable.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Today was different. He walked home. Evan didn’t fume; he didn’t fantasize. Instead, he thought about Medipharm; he thought about "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("work")]), _vm._v(". He tried to conjure up deep thoughts, but they wouldn’t emerge. He missed them.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Normally, the idea of thinking about work bullshit after a missed opportunity would anger Evan, but not today. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Why?")]), _vm._v(" The answer struck him as he glanced up at the El Dorado’s twin towers. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Money. Success. The twin pillars of life. Medipharm. The path to both.")]), _vm._v(" Content that he wasn’t losing it, Evan relaxed, took a deep breath of air heavily scented with roasting Nuts 4 Nuts, and enjoyed the circular stroll.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec68b368","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter7.vue
// module id = 90
// module chunks = 0